import React from "react";
import cx from "classnames";
import FullScreenModal from "@/features/shell/components/FullScreenModal/FullScreenModal";
import { useShellStore } from "@/features/shell/stores/shellStore";

import * as styles from "./CaptchaPuzzleModal.module.scss";

export const CaptchaPuzzleModal = () => {
  const captcha = useShellStore((state) => state.captcha);
  const setModal = useShellStore((state) => state.setModal);
  const closeCaptchaPuzzle = useShellStore((state) => state.closeCaptchaPuzzle);

  const handleClose = () => {
    closeCaptchaPuzzle();
    setModal(null);
  };

  return (
    <FullScreenModal
      className={cx({
        [styles.invisible]: !captcha.visible,
      })}
      isOpen={captcha.required}
      onClose={handleClose}
    >
      <div
        id="captcha-container"
        className={cx(styles.captchaPuzzle, {
          [styles.visible]: captcha.visible,
        })}
      />
    </FullScreenModal>
  );
};
